import React, { Component } from 'react';
import clone from 'clone';

import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from './Dialog';

class ListExportDialog extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      from: this.props.from === undefined ? '' : this.props.from,
      show: this.props.show,
      height: this.props.height,
      width: this.props.width,
      headers: this.props.headers,
      data: this.props.data === undefined ? [] : this.props.data,
      tiles: [
        { icon:'icon-pixelvicon-document-2', text:'csv', active: true }
      ]
    };
    this.onExport = this.onExport.bind( this );
    this.onClose = this.onClose.bind( this );
    this.onTileClicked = this.onTileClicked.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    this.setState( {
      from: nextProps.from === undefined ? '' : nextProps.from,
      show: nextProps.show,
      height: nextProps.height,
      width:  nextProps.width,
      headers: nextProps.headers,
      data: nextProps.data === undefined ? [] : nextProps.data,
    } );
  }

  onExport( e ) {
    const tiles = this.state.tiles;
    let format = 'excel';
    for( var index = 0; index < tiles.length; index++ ) {
      const tile = tiles[ index ];
      if( tile.active === true ) {
        format = tile.text.toLowerCase();
        break;
      }
    }

    if( format === 'excel' ) {
      this.onExportExcel( e );
    } else if( format === 'csv' ) {
      this.onExportCSV( e );
    } else {
      this.onExportExcel( e );
    }

  }

  onExportExcel( e ) {
    const headers = this.state.headers;
    const rows = this.state.data;
    var output = '';
    var filename = '';
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf( 'MSIE ' );
    var columns = [];
    var index = 0;

    // Get the columns
    if( headers !== undefined ) {
      if( headers.length > 0 ) {
        for( index = 0; index < headers.length; index++ ) {
          const header = headers[ index ];
          columns.push( header.text );
        }
      }
    }
    //Build the columns
    if( columns !== undefined ) {
      if( columns.length > 0 ) {
        for( index = 0; index < columns.length; index++ ) {
          if( index > 0 ) {
            output += '\t';
          }
          output += columns[ index ];
        }
      }
    }
    output += '\r\n';

    //Build the rows
    if( rows !== undefined ) {
      if( rows.length > 0 ) {
        for( var rowindex = 0 ; rowindex < rows.length; rowindex++ ) {
          const row = rows[ rowindex ];
          for( index = 0; index < headers.length; index++ ) {
            const header = headers[ index ];
            if( index > 0 ) {
              output += '\t';
            }
            if( row[ header.column ] !== null && row[ header.column ] !== undefined ) {
              output += row[ header.column ];
            }
          }
          output += '\r\n';
        }
      }
    }

    if ( msie > 0 || !!navigator.userAgent.match( /Trident.\*rv:11\./ ) ) {
      filename = this.state.from.replace( ' ','_' ).toLowerCase() + '.xls';
      var popup = window.open( 'about:blank', '_blank' );
      popup.document.write( output );
      popup.document.execCommand( 'SaveAs', true, filename );
    } else {
      filename = this.state.from.replace( ' ','_' ).toLowerCase() + '.xls';
      var uri = 'data:application/vnd.ms-excel,' + encodeURIComponent( output );
      var link = document.createElement( 'a' );
      link.href = uri;
      link.style = 'visibility:hidden';
      link.download = filename;
      document.body.appendChild( link );
      link.click();
      document.body.removeChild( link );
    }

    this.onClose( e ) ;
  }

  onExportCSV( e ) {
    const headers = this.state.headers;
    const rows = this.state.data;
    var output = '';
    var filename = '';
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf( 'MSIE ' );
    var columns = [];
    var index = 0;

    // Get the columns
    if( headers !== undefined ) {
      if( headers.length > 0 ) {
        for( index = 0; index < headers.length; index++ ) {
          const header = headers[ index ];
          columns.push( header.text );
        }
      }
    }
    //Build the columns
    if( columns !== undefined ) {
      if( columns.length > 0 ) {
        for( index = 0; index < columns.length; index++ ) {
          if( index > 0 ) {
            output += ',';
          }
          output += columns[ index ];
        }
      }
    }
    output += '\r\n';

    //Build the rows
    if( rows !== undefined ) {
      if( rows.length > 0 ) {
        for( var rowindex = 0 ; rowindex < rows.length; rowindex++ ) {
          const row = rows[ rowindex ];
          for( index = 0; index < headers.length; index++ ) {
            const header = headers[ index ];
            if( index > 0 ) {
              output += ',';
            }
            if( row[ header.column ] !== null && row[ header.column ] !== undefined ) {
              output += row[ header.column ];
            }
          }
          output += '\r\n';
        }
      }
    }

    if ( msie > 0 || !!navigator.userAgent.match( /Trident.\*rv:11\./ ) ) {
      filename = this.state.from.replace( ' ','_' ).toLowerCase() + '.csv';
      var popup = window.open( 'about:blank', '_blank' );
      popup.document.write( output );
      popup.document.execCommand( 'SaveAs', true, filename );
    } else {
      filename = this.state.from.replace( ' ','_' ).toLowerCase() + '.csv';
      var uri = 'data:application/vnd.ms-excel,' + encodeURIComponent( output );
      var link = document.createElement( 'a' );
      link.href = uri;
      link.style = 'visibility:hidden';
      link.download = filename;
      document.body.appendChild( link );
      link.click();
      document.body.removeChild( link );
    }

    this.onClose( e ) ;
  }

  onClose( e ) {
    if( this.props.onClose !== undefined ) {
      this.props.onClose( e );
    }
  }

  onTileClicked( e ) {
    let tiles = clone( this.state.tiles );
    for( var index = 0; index < tiles.length; index++ ) {
      if( index === e.target.index ) {
        tiles[ index ].active = true;
      } else {
        tiles[ index ].active = false;
      }
    }
    this.setState( {
      tiles: tiles
    } );
  }

  onRenderTiles( ) {
    let tiles = this.state.tiles;
    const tileoptions = tiles.map( ( tile, index ) => {
      const tilekey = 'export-title-' + index.toString();
      return (
        <ExportTile key={tilekey} index={index} icon={tile.icon} text={tile.text} active={tile.active} onClick={this.onTileClicked}/>
      );
    } );
    return tileoptions;
  }

  render() {
    const caption = 'Export ' + this.state.from + ' Data';
    return (
      <Dialog show={this.state.show} height={this.state.height} width={this.state.width} >
        <DialogHeader caption={caption} closeButton onClose={this.onClose} />
        <DialogBody>
          <span className="list-export-panel">
            {this.onRenderTiles()}
          </span>
        </DialogBody>
        <DialogFooter>
          <button className="list-export-dialog-button" onClick={this.onExport}>Export</button>
        </DialogFooter>
      </Dialog>
    );
  }
}

export class ExportTile extends Component {
  constructor( props ){
    super( props );
    this.state = {
      index: this.props.index === undefined ? 0 : this.props.index,
      icon: this.props.icon === undefined ? '' : this.props.icon,
      text: this.props.text === undefined ? '' : this.props.text,
      active: this.props.active === undefined ? false : this.props.active
    };
    this.onClick = this.onClick.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    this.setState( {
      index: nextProps.index === undefined ? 0 : nextProps.index,
      icon: nextProps.icon === undefined ? '' : nextProps.icon,
      text: nextProps.text === undefined ? '' : nextProps.text,
      active: nextProps.active === undefined ? false : nextProps.active
    } );
  }

  onClick( e ) {
    e.target.index = this.state.index;
    if( this.props.onClick !== undefined ) {
      this.props.onClick( e );
    }
  }

  render( ) {
    const iconclassname = 'list-export-tile-icon ' + this.props.icon;
    if( this.state.active === true ) {
      return (
        <span className="list-export-tile-selected">
          <i className={iconclassname} />
          <span className="list-export-tile-text">{this.state.text}</span>
        </span>
      );
    } else {
      return (
        <span className="list-export-tile" onClick={this.onClick}>
          <i className={iconclassname} />
          <span className="list-export-tile-text">{this.state.text}</span>
        </span>
      );
    }
  }
}

export default ListExportDialog;



// WEBPACK FOOTER //
// ./src/presentation/ListExportDialog.js